export const konnoAyaka = `たくさんのファンの方に愛されている、アシガールの唯役を演じることができて、とても嬉しく思います！
朗読劇は、私自身、初めての試みなのでどのようなモノになっていくのか全くわからない状態ではありますが、キャストの皆様はじめスタッフの皆様のお力をお借りして楽しみたいなと思っています。
唯のおっちょこちょいだったりする愛されキャラを、私も皆さんに愛されるような演技で丁寧に作り上げていきたいです。

【プロフィール】
1999年6月24日生まれ。「non-no」専属モデル。
「仮面ライダージオウ」(テレビ朝日)で連続ドラマ初出演を果たす他、映画「藍に響け」（奥秋泰男監督）ではW主演を務め、数多くの作品に出演。
2023年は、「サブスク彼女」（朝日放送テレビ）で地上波連続ドラマ初主演を務めるなど、モデル・女優として活躍の場を広げている。
現在放送の「なれの果ての僕ら」（テレビ東京）に、葉月依莉奈役でレギュラー出演中。
`;

export const hondaMiyu = `速川唯を務めさせていただきます。本田望結です！
役者人生16年目にして、念願の朗読劇！
映像や舞台とは違う、朗読劇ならではの絵をお客様に想像していただき完成する仕組みにとてもワクワクしています！初めてのことですのでお稽古からとても楽しみです。皆様にお会いできる日を楽しみに全力で取り組んでまいります！

【プロフィール】
2004年6月1日生まれ。京都府出身。
3歳から芸能活動を始め、ドラマ「家政婦のミタ」(日本テレビ系)への出演が話題になり、その後多くのドラマ、映画に出演。近年の出演作はドラマ「少年のアビス」(22年・MBS系)、「ばかやろうのキス」(22年・日本テレビ系)、映画「それいけ！ゲートボールさくら組」(23年)、「きさらぎ駅」(22年)など。フィギュアスケーターとしても活躍。
`;

export const masudaToshiki = `羽木九八郎忠清を演じさせていただきます、増田俊樹です。
原作の漫画を読ませていただきましたが、とても！おもしろいです！シリアスやコメディがポップに描かれていて、こんなに読みやすいタイムスリップ戦国ラブストーリーがあったのか！？とびっくりしました。
朗読では、どこからどこまでが描かれるのか今から楽しみでなりません。唯と若君が苦難を乗り越えた先にある未来は！？腹が決まったら参れ！

【プロフィール】
3月8日生まれ。広島県出身。
主な出演作品は、アニメ「刀剣乱舞-花丸-」（加州清光 役）、「アイドリッシュセブン」（和泉一織 役）、「僕のヒーローアカデミア」（切島鋭児郎役）など。
`;

export const hukahoriMiku = `この度、朗読劇「アシガール」に出演させていただくことになりましたBALLISTIK BOYZ深堀未来です。
自分は演技の経験などもほとんどないのですが、しっかりと稽古をして、観に来てくださる方々にアシガールの世界観を存分に感じでいただけるように全力で頑張り、自分の役をしっかり演じて朗読させていただきたいと思います！
不慣れなところがあるかもしれませんが、温かい応援のほど何卒宜しくお願い致します！

【プロフィール】
2019年にデビュー。
その年東南アジア5箇所をめぐるプロモーションツアーを行い、昨年8月から活動拠点をタイにも移し、半年間タイでの武者修行を経験。
その期間にリリースした楽曲「Drop Dead feat.TRINITY」はT-POPチャートを賑わす。
2月にはタイでの単独公演を開催、3月に帰国し4月から日本国内のツアーも16公演完走。日本からアジア、世界へと目指すグローバルスタンダードなグループ、BALLISTIK BOYZのメンバー。
`;

export const kusakawaTakuya = `皆さま、初めまして。
羽木九八郎 忠清を演じさせていただきます。草川拓弥です。
朗読劇の世界に飛び込むのは今回がほぼ初めてと言ってもいいかもしれません。
一度経験させていただいた時は自分のグループや後輩グループもいたのでどこか安心感があったので、いまはまさに唯のように新しい環境にいきなり飛び込むようなワクワクとした気持ちです。
また今回は朗読劇だけではなく、生バンドをいれた音楽との融合もあります。自分も普段からステージに立っている人間なので、どんな世界観になるのかとても楽しみです。
1回しかない特別な機会を、悔いのないよう精一杯やらせていただきます。
皆さんにとっても特別な日になりますように。

【プロフィール】
1994年11月24日、東京都生まれ。超特急のメンバーとしても活躍中。
’22年はドラマ「みなと商事コインランドリー」に主演のほか、「デブとラブと過ちと！」でW主演。
'23年には「ラストマン-全盲の捜査官-」に出演し、7月には「みなと商事コインランドリー2」が放送される。
`;

export const minetaHiromu = `速川尊を演じさせていただきます、峯田大夢です。
朗読劇に参加させて頂くにあたり原作を読ませて頂いたのですが、一気に引き込まれあっという間に次々と読んでしまいました…。
そんな素敵な作品に出会えた事に感謝です！
今回の朗読劇では一体どこまで描かれるのか、どんな掛け合いが生まれるのか僕自身とても楽しみです。
是非、原作を読んでご来場していただければと思います！
読んでいなくても必ず読みたくなるような朗読劇をお届け出来るよう一生懸命に尊を演じさせて頂きます！

【プロフィール】
6月24日生まれ。山形県出身。O型。
代表作：TVアニメ「ブルーピリオド」矢口八虎 役（主人公）、「セスタス‐The Roman Fighter‐」セスタス 役（主人公）、吹き替え「HEARTSTOPPER ハートストッパー」チャーリー・スプリング 役（主人公）など
`;

export const shinYuki = `今回「アシガール」の朗読劇に参加させていただけることになりました。
アシガールで重要なタイムマシンをつくる尊くんはとても頭が良い子だと思いますのでなんとか負けずに演じさせていただきたいと思います。
彼のようにお芝居も様々なひらめきで取り組めたらいいなと今からワクワクしております。
楽しいものにできるよう、僕自身も楽しんで朗読させて頂きます。
よろしくお願い致します！

【プロフィール】
3月6日生まれ。神奈川出身。A型。
2006年、「ヘボット！」のモエル役にてデビュー。
代表作：「東京リベンジャーズ」花垣武道役「うちの会社の小さい先輩の話」篠崎拓馬役
「天国大魔境」タカ役など
`;

export const umedaShuichirou = `尊役をつとめさせていただきます、梅田修一朗と申します。
この素敵な物語を朗読劇というかたちで、生で観てくださるみなさんへ、素敵な演出、素敵なキャストの方々と、しっかり言葉を届けられるようにがんばります。観劇してくださった時間が、思い出に残る時間になりますように。どうぞよろしくお願いいたします！

【プロフィール】
10月11日生まれ。千葉出身。AB型。
アプリゲーム「Readyyy!」高千穂亜樹にてデビュー
代表作：「ゾン100〜ゾンビになるまでにしたい100のこと〜」天道輝役「可愛いだけじゃない式守さん」和泉役など
`;

export const kumagaiKentarou = `朗読劇「アシガール」に出演させていただきます。熊谷健太郎です。
主人公がタイムスリップした先は戦国時代。そこで行われるラブコメディ。そんな世界の中で、僕は果たしてどんな表現ができるのか、どれだけ引き出しを作って持っていけるか。
非常に大きなチャレンジをさせていただけるのではないかと思っております。
精一杯努めます。何卒よろしくお願いいたします。

【プロフィール】
2月16日生まれ。
声優。東京俳優生活協同組合所属。
主な出演作品：【アニメ】ダンジョン飯（ライオス役）、
池袋ウエストゲートパーク（真島マコト役）、
グランクレスト戦記（テオ・コルネーロ役）、
【外画】ウェンズデー（ゼイヴィア役）など。
`;

export const yamashitaSeiichirou = `朗読劇「アシガール」、成之役で出演します山下誠一郎です。演じ甲斐のある役どころなのは勿論、俳優として活躍する方々との共演は心が躍ります。とても光栄な事でありまたこの機会に感謝しながら、一度きりの公演を楽しみたいと思います。応援よろしくお願いします！

【プロフィール】
5月21日生まれ。広島県出身。大沢事務所所属。
2012年に声優デビューし、2013年「ワルキューレロマンツェ」で初主演を演じる。
代表作：「orange」（成瀬翔）、「ホリミヤ」（石川透）、「陰の実力者になりたくて！」（シド・カゲノー/シャドウ）、「魔法使いの嫁２」（リアン・スクリム＝ジョー）、「東京リベンジャーズ」（鶴蝶）、「刀剣乱舞-ONLINE-」（薬研藤四郎、愛染国俊）、他多数
`;

export const tachibanaTatsumaru = `タイムマシンで戦国時代！？もし自分がこの世界に飛び込んだら怖くて怖くてきっとなにも出来ないかもしれません…ドキドキハラハラの展開にあっという間に時間は過ぎていってしまうでしょう！精一杯演じさせていただき、皆様の記憶に残る最高の時間をお届け出来るように頑張ります！！一緒にタイムスリップしてみませんか？劇場でお待ちしております！！

【プロフィール】
４月２１日生まれ。福井県出身
10歳より大衆演劇舞台に立ち、2010年から2015年まで座長として活動。
退団後は、舞台やミュージカルで表現の幅を増やし、声優としても活動している。
主な出演作は「Fate/strange Fake」ジェスター役、「アオアシ」大友栄作役
「ヴィンランド・サガ」トルフィン役、舞台「斬劇　戦国BASARA」山中鹿之助役、「イケメン戦国THE STAGE」上杉謙信役など他多数
`;

export const ozakiYuka = `音楽朗読劇『アシガール』に出演出来ること、とても光栄です！
漫画原作で、映像化もされていてファンの方が沢山いる作品でもあるので、皆さんの知っているアシガールの世界をより体感して頂けるよう、公演まで共演者の皆さんと頑張りたいと思います。
音楽朗読劇ということで、生バンドの皆さんとの共演もどんな化学反応が起こるのか当日が楽しみです。

【プロフィール】
5月15日生まれ。東京都出身
主な出演作品には、アニメ「江戸前エルフ」（小金井小糸 役）、「けものフレンズ」（サーバル役）、「ファイヤーバディ」（ピストン 役）、「少女☆歌劇レビュースタァライト」（鳳ミチル 役）など。`;

export const nakazhimaMegumi = `阿湖役を演じさせていただきます、中島愛です。原作のコミカルさやテンポの良さ、そしてチャーミングな登場人物たちの心模様を、音楽朗読劇という形で表現するステージ。参加できることがとても嬉しいです！生バンドと朗読の融合、かなりライブ感のある公演になりそうです。今回ならではの空間を楽しみながら演じたいと思います！よろしくお願いいたします。

【プロフィール】
６月５日生まれ。茨城県出身
2007年マクロスシリーズの新作ヒロインオーディションで５０００通を越える応募の中から合格し、声優としてデビュー。歌手としても今年１５周年記念ライブも行い、更に活動の幅を広げている。
主な出演作は「マクロスF」ランカ・リー役、「ハピネスチャージプリキュア!」愛乃めぐみ役、「君のいる町」枝葉 柚希役、海外アニメ「ティニピン」マヤ役など他多数
`;

export const koichiMakoto = `以前放送していたドラマを拝見しておりまして、オファーを頂けた時「まさか、あの面白い作品に！」と心躍りました。主人公の唯ちゃんが底抜けに明るくて猪突猛進、THE面白い女なので、見ていてとてもパワーを貰えます！笑いあり、トキメキあり、そして戦いあり。ラブコメエンターテイメント。原作のあの空気感を朗読劇でどう表現するのか。皆さま、お楽しみに！

【プロフィール】
２月１７日生まれ。東京都出身
声優として活動する以前は主に舞台を中心に活動。
2016年「ナースウィッチ小麦ちゃんR」で声優デビューし、その後声優としての活動、
数多くの人気作品に出演。
主な出演作は「るろうに剣心-明治剣客浪漫譚-」明神弥彦役、「地獄楽」ヌルガイ役、
「火狩の王」火穂役、「アイドルマスターシンデレラガールズ」結城晴役
吹き替え「プチ・ニコラ_パリがくれた幸せ」ニコラ役など他多数
`;
